import axios from 'axios';
import store from '../store';
import { selectCurrentProject } from '../store/slices/projects';

axios.defaults.baseURL = process.env.REACT_APP_DEV_URL || document.location.origin;

/**
 * LF360-1970 — the session travels in a cookie the page cannot read.
 *
 * `withCredentials` is what makes the browser send it at all on a cross-origin
 * request, and keep the one that comes back from a login. Deployed, the portal
 * and `/api` are the same host and this changes nothing; in development they
 * are two ports on `localhost`, which is cross-origin as far as the browser is
 * concerned. The backend answers credentialled CORS only for origins on its
 * allowlist.
 */
axios.defaults.withCredentials = true;

/**
 * Says "this request is the portal's", so the backend knows which cookie to
 * read.
 *
 * One browser can hold both this and a subject's web-app session — an
 * administrator who is also a subject, and anyone running both front ends on
 * `localhost`, where cookies are shared across ports. The header is the only
 * thing that can tell them apart, and a page on another site cannot add one,
 * so it costs nothing and settles it.
 */
const PORTAL_CLIENT_HEADER = 'X-LF360-Portal';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('user_token');

  if (!config.headers) {
    config.headers = {};
  }

  config.headers[PORTAL_CLIENT_HEADER] = '1';

  /**
   * A token is no longer stored at sign-in, so this is only ever a session
   * from before the cookie release — and it has to keep working, or deploying
   * this would sign out every tab that is open at that moment. It goes away on
   * its own: the next sign-in leaves nothing behind, and logging out clears it.
   */
  if (!config.headers.Authorization && token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const state = store.getState();
  const project = selectCurrentProject(state);
  const pid = project?.id;

  if (pid) {
    config.headers['X-Project-Id'] = pid;
  } else {
    delete config.headers['X-Project-Id'];
  }

  return config;
});